// src/services/admin/emails.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const emailsApi = createApi({
  reducerPath: "emails",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_URL}/api/admin/admin-emails/`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["Emails"],
  endpoints: (builder) => ({
    sendScholarshipPDF: builder.mutation({
      query: (formData) => ({
        url: `send-custom-email-with-pdf`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Emails"],
    }),
  }),
});

export const { useSendScholarshipPDFMutation } = emailsApi;
export default emailsApi;
export { emailsApi };
